import React from 'react';
import { connect } from 'react-redux';
import { complete as completeCreator } from '../store/modules/state/complete';

/**
 * Takes Redux store and `unlock` and `complete` describing activity requirements, and returns a status prop that is one of `'locked'`, `'unlocked'`, or `'completed'`.
 *
 * @param {object} store Redux store
 * @param {object} props Component's props
 * @returns {object} Object containing a `status` prop.
 */
const mapToStatus = (store, props) => {
  const { completed } = store.state;
  const { unlock, complete } = props;

  // if the stores says complete, then return complete
  if (completed[props.id]) {
    return { status: 'completed' };
  }

  // if not unlock or complete props, default is unlocked
  if (!unlock && !complete) {
    return { status: 'unlocked' };
  }

  const areEnoughCompleted = (arr, count) =>
    arr.filter(id => completed[id]).length >= count;

  const areAllCompleted = arr => {
    if (typeof arr === 'string') {
      return completed[arr];
    }

    return Array.isArray(arr)
      ? arr.filter(item => {
          // array: true if any completed
          if (Array.isArray(item)) {
            return areEnoughCompleted(item, 1);
          }
          // object: e.g. { any: 2, of: [a,b,c] }
          if (item.any && item.of) {
            return areEnoughCompleted(item.of, item.any);
          }

          // string
          return completed[item];
        }).length === arr.length
      : null;
  };

  // check the complete prop
  if (areAllCompleted(complete)) {
    return { status: 'completed' };
  }

  // no unlock prop, but a complete prop
  if (!unlock && complete) {
    return { status: 'unlocked' };
  }

  // check the unlock prop
  if (areAllCompleted(unlock)) {
    return { status: 'unlocked' };
  }

  return { status: 'locked' };
};

function withStatus(Component) {
  return connect(mapToStatus)(
    class WithStatus extends React.Component {
      componentDidUpdate(prevProps) {
        const { status, dispatch, id } = this.props;

        // mark complete when status has changed
        if (status === 'completed' && prevProps.status !== 'completed' && id) {
          dispatch(completeCreator(id));
        }
      }

      render() {
        const { dispatch, ...props } = this.props;
        return <Component {...props} />;
      }
    }
  );
}

export default withStatus;
